import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import Button from '@mui/material/Button';
import { Card, Typography } from '@mui/material';

import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';

import { useTranslate } from 'src/locales';
import { channelStep1Data } from 'src/_mock';

import { Image } from 'src/components/image';

import { useChannelContext } from '../hooks';

// ----------------------------------------------------------------------

export function Step1() {
  const { t } = useTranslate('translation');

  const { onChangeStep, state: channelState, onSelectChannel } = useChannelContext();

  return (
    <Box sx={{ height: '90%', display: 'flex', flexDirection: 'column' }}>
      <Grid container spacing={3} justifyContent="space-between">
        {channelStep1Data(t).map((data, index) => (
          <Grid key={index} size={{ xs: 12, md: 6 }}>
            <Card
              sx={{
                p: 4,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                margin: '0 auto',
                cursor: 'pointer',
                width: '90%',
                height: '150px',
                border: channelState.channelType === data?.value ? '1px solid #00A76F' : 'none',
              }}
              onClick={() => onSelectChannel(data?.value)}
            >
              <Box sx={{ display: 'flex' }}>
                <Image src={data.icon} alt={data.icon} sx={{ width: '75px', height: '75px' }} />
              </Box>
              <Typography variant="h6">{data.channel_name}</Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{ flexGrow: 1 }} />
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Box>
          <Button
            variant="outlined"
            color="inherit"
            component={RouterLink}
            href={paths.channel.root}
            onClick={() => onChangeStep('back')}
          >
            {t('PREVIOUS')}
          </Button>
        </Box>
        <Box>
          <Button
            fullWidth
            size="small"
            type="submit"
            variant="contained"
            disabled={!channelState.channelType}
            onClick={() => onChangeStep('next')}
          >
            {t('NEXT')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
